import axios from "axios";
import { AbstractServiceProps } from "./AbstractService.types";

/**
 * @author noone
 * 
 * @param props 
 */
export async function getAbstractService(props: AbstractServiceProps) {
    try {
        return await axios({
            method: props.type,
            url: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + props.path,
            withCredentials: props.withCredentials,
            headers: props.headers,
            params: props.params,
            data: props.data,
            paramsSerializer: props.paramsSerializer,
            onUploadProgress: props.onUploadProgress
        });
    } catch(error) {
        props.failCallback(error);
      };

}